import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    ValidateShippingAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";
import { BillToModel, CountryModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { beginCheckout } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = Handler<
    {},
    {
        cart: Cart;
        billTo: BillToModel;
        shipTo: ShipToModel;
        country: CountryModel | undefined;
        shipTos: ShipToModel[];
    }
>;

export const TriggerBeginCheckoutEvent: HandlerType = props => {
    const session = getSession(props.getState());
    const itemdata = [];
    if (props.cart?.cartLines && props.cart?.cartLines.length) {
        for (let i = 0; i < props.cart?.cartLines.length; i++) {
            itemdata.push({
                item_name: props.cart?.cartLines[i].shortDescription,
                item_id: props.cart?.cartLines[i].erpNumber,
                quantity: props.cart?.cartLines[i].qtyOrdered,
                price: props.cart?.cartLines[i].pricing?.actualPrice,
                item_brand: props.cart?.cartLines[i].brand?.name ? props.cart?.cartLines[i].brand?.name : "",
            });
        }
    }
    beginCheckout({
        event: "begin_checkout",
        ecommerce: {
            currency: session?.currency?.currencyCode,
            value: props.cart?.orderSubTotal,
            items: itemdata,
        },
    });
};

addToChainAfter(chain, ValidateShippingAddress, TriggerBeginCheckoutEvent);